// extracted by mini-css-extract-plugin
var _1 = "jznNJ0wW";
var _2 = "Q1mAOsuR";
var _3 = "Q1mAOsuR";
var _4 = "bMFG9IQ9";
var _5 = "Dmpk9VLe";
var _6 = "bMFG9IQ9";
var _7 = "Dmpk9VLe";
var _8 = "drVuAFYe";
var _9 = "drVuAFYe";
var _a = "Gekar5Dz";
export { _1 as "clamped", _2 as "main-info", _3 as "mainInfo", _4 as "product-image-and-main-info", _5 as "product-title", _6 as "productImageAndMainInfo", _7 as "productTitle", _8 as "title-and-category", _9 as "titleAndCategory", _a as "traits" }
